import { createFileRoute } from '@tanstack/react-router'
import { AiSection } from '~/components/marketing/ai-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'IA do Planno — assistente e renders para arquitetos | Planno'
const PAGE_DESCRIPTION =
  'Assistente que conhece arquivos, conversas, orçamento e cronograma do projeto. Render fotorrealista a partir do print do SketchUp em segundos. Rascunhos de termos, contratos e propostas.'

export const Route = createFileRoute('/recursos/ia')({
  component: IaPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/recursos/ia',
      title: PAGE_TITLE,
    }),
})

function IaPage() {
  return (
    <MarketingShell>
      <AiSection headingLevel="h1" />
    </MarketingShell>
  )
}
